import SearchCard from "./SearchCard";
import { useContext } from "react";
import { clearFilters, SearchContext } from "../../pages/Search";
import { CircleX, RefreshCw, SearchX } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSearchParams } from "react-router-dom";
import { useSearchStore } from "@/stores/SearchStore";
import { Separator } from "@/components/ui/separator";

function List({ render, data }) {
  const empty = Array.from(Array(10).keys());
  if (!data) return <div>{empty.map(render)}</div>;
  return (
    <div>
      <div className="text-sm text-muted-foreground/80 mb-4 text-end flex items-center justify-end gap-4">
        <Separator className="flex-1 mx-2" />
        {data.length} Result
        {data.length !== 1 ? "s" : ""} Found
      </div>
      <div className="mt-8 overflow-visible"> {data.map(render)}</div>
    </div>
  );
}

function NoResultsFound() {
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="relative mb-8">
        <div className="absolute inset-0 animate-pulse bg-primary/10 rounded-full blur-xl" />
        <SearchX className="relative w-16 h-16 text-primary/70 bg-muted rounded-md p-1" />
      </div>
      <h3 className="text-xl font-semibold mb-2">No matching results found</h3>
      <p className="text-[var(--gray-600)] max-w-md mb-6">
        We couldn't find any results matching your search criteria. Try
        adjusting your filters.
      </p>
      <div className="flex gap-4">
        <Button
          variant="outline"
          onClick={() => {
            const newSearchParams = clearFilters(searchParams); // Clear filters and get newSearchParams

            // Set the new searchParams
            setSearchParams(newSearchParams);

            // Update global storage
            useSearchStore.setState({
              searchPageSearchParams: newSearchParams,
            });
          }}
        >
          <CircleX />
          Clear all filters
        </Button>
      </div>
    </div>
  );
}

function SearchList() {
  const { searchResults, isLoading } = useContext(SearchContext);
  if (!isLoading && searchResults && searchResults.length === 0)
    return <NoResultsFound />;
  if (!isLoading && !searchResults) return null;
  return (
    <List
      data={searchResults}
      render={(result, i) => (
        <SearchCard key={i} rowData={result} isLoading={isLoading} />
      )}
    />
  );
}

export default SearchList;
